import { render, staticRenderFns } from "./seeds.vue?vue&type=template&id=f2bc028a&scoped=true&"
import script from "./seeds.vue?vue&type=script&lang=js&"
export * from "./seeds.vue?vue&type=script&lang=js&"
import style0 from "./seeds.vue?vue&type=style&index=0&id=f2bc028a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2bc028a",
  null
  
)

export default component.exports